import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  AcceptedQuoteDepositRootScreenParamList,
  CheckoutRootParamList,
  CheckoutCreateSaleQuoteRootScreenParamList,
} from "../../../../types";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { useCreateSaleQuoteRootScreenContextProvider } from "../CreateSaleQuoteRootScreen/hooks";
import { AcceptedQuoteDepositScreen } from "../AcceptedQuoteDepositScreen";
import React from "react";
import { SaleState } from "../../../../utilities/data/model/Sale";
import { PaymentActionsContext } from "../PaymentRootScreen/context";
import { PaymentRootScreen } from "../PaymentRootScreen";

export type AcceptedQuoteDepositRootScreenProps = StackScreenProps<
  CheckoutCreateSaleQuoteRootScreenParamList & CheckoutRootParamList,
  "AcceptedQuoteDepositRootScreen"
>;

export const AcceptedQuoteDepositRootScreen = ({
  navigation,
}: AcceptedQuoteDepositRootScreenProps) => {
  const { sale } = useCreateSaleQuoteRootScreenContextProvider();

  const Stack =
    createStackHeaderNavigator<AcceptedQuoteDepositRootScreenParamList>();

  const handleOnAfterPayment = React.useCallback(async () => {
    await sale.transitionToState(SaleState.QUOTE_OPEN);
    navigation.reset({
      index: 0,
      routes: [{ name: "CheckoutSummaryRootScreen" }],
    });
    return false;
  }, []);

  return (
    <PaymentActionsContext.Provider
      value={{ onAfterPayment: handleOnAfterPayment }}
    >
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
        }}
      >
        <Stack.Group
          screenOptions={{
            headerLeft: () => (
              <ModalCloseButton
                onPress={() => navigation.pop()}
                type="Cancel"
              />
            ),
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <Stack.Screen
            name="AcceptedQuoteDepositScreen"
            component={AcceptedQuoteDepositScreen}
            options={{
              title: "",
            }}
          />
          <Stack.Screen
            options={{
              headerShown: false,
            }}
            name="PaymentRootScreen"
            component={PaymentRootScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </PaymentActionsContext.Provider>
  );
};
